module.exports = __webpack_public_path__ + "static/onas.40d0fd19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/onas.jpg
// module id = 702
// module chunks = 196067925415476